// Created by hejikun on 2017/10/25 0025.
let state = {}

const actions = {}

const getters = {}

const mutations = {}

export default {
  state,
  mutations,
  actions,
  getters
}
